var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    xmlSpace: "preserve",
    id: "iconmonstrlinkbottom",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstrlinkbottom-bezier",
    stroke: "none",
    fill: "rgb(0, 122, 255)",
    d: "M 1.54,1.79 C 1.54,1.17 1.63,0.57 1.79,0 2.71,-3.17 5.93,-5.19 9.23,-4.51 L 9.23,-1.33 C 7.73,-1.92 6.01,-1.38 5.14,0 4.81,0.52 4.62,1.13 4.62,1.79 L 4.62,7.88 C 4.62,9.73 6.12,11.23 7.97,11.23 9.82,11.23 11.32,9.73 11.32,7.88 L 11.32,6 C 12.52,5.49 13.57,4.71 14.4,3.74 L 14.4,7.88 C 14.4,11.43 11.52,14.31 7.97,14.31 4.42,14.31 1.54,11.43 1.54,7.88 L 1.54,1.79 Z M 1.54,-7.88 L 1.54,-3.73 C 2.38,-4.71 3.43,-5.49 4.62,-6 L 4.62,-7.88 C 4.62,-9.72 6.12,-11.23 7.97,-11.23 9.82,-11.23 11.32,-9.72 11.32,-7.88 L 11.32,-1.79 C 11.32,0.07 9.81,1.56 7.97,1.56 7.54,1.56 7.09,1.48 6.71,1.33 L 6.71,4.51 C 7.13,4.6 7.52,4.64 7.97,4.64 9.12,4.64 10.28,4.34 11.32,3.7 12.67,2.87 13.7,1.56 14.15,0 14.31,-0.57 14.4,-1.17 14.4,-1.79 L 14.4,-7.88 C 14.4,-11.43 11.52,-14.31 7.97,-14.31 4.42,-14.31 1.54,-11.43 1.54,-7.88 Z M 1.54,-7.88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBottom);
export default __webpack_public_path__ + "static/media/link-bottom.19fcaaee8c64b4ab4a3a876769c64da0.svg";
export { ForwardRef as ReactComponent };